import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FirestoreService from './assets/js/firestore_instance';
import Home from './components/Home';
import Preloader from './components/Preloader';
import SignIn from './components/SignIn';
import Dashboard from './components/Dashboard';
import Layout from './components/Layout';
import Auth from './components/Auth';
import StagedGroups from './components/StagedGroups';
import Confirmation from './components/Confirmation';
import FinishSetup from './components/FinishSetup';
import SetupAdmin from './components/SetUpAdmin';
import { Toaster } from 'react-hot-toast';
import DownloadTheApp from './components/DownloadTheApp';
import { Navigate } from 'react-router-dom';
import CreateOrganization from './components/CreateOrganization';
import GroupDetailPage from './components/GroupDetailPage';
import Features from './components/Features';
import ScrollToTop from './components/ScrollToTop';



function App() {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const initFirebase = async () => {
      try {
        await FirestoreService.initialize();
        setIsInitialized(true);
      } catch (error) {
        console.error('Error initializing Firebase:', error);
      }
    };

    initFirebase();
  }, []);

  if (!isInitialized) {
    return <Preloader />
  }

  return (
    <Router>
      <ScrollToTop />
      <Toaster 
        position="top-center"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#333',
            color: '#fff',
          },
        }}
      />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/create-organization" element={<CreateOrganization />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/staged-groups" element={<StagedGroups />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/finish-setup" element={<FinishSetup />} />
          <Route path="/setup-admin" element={<SetupAdmin />} />
          <Route path="/groups/:groupId" element={<GroupDetailPage />} />
          <Route path="/download-joltchat" element={<DownloadTheApp />} />
          <Route path="/features" element={<Features />} />
          <Route path="*" element={<Navigate to="/download-joltchat" />} /> 
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;